var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyValuation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,113.69a6,6,0,0,0-4.95,2.62L219,109.46a6,6,0,0,0,.4-2.11,5.87,5.87,0,0,0-.4-2.11l13.18-6.86a6,6,0,1,0-1-3.36,5.87,5.87,0,0,0,.4,2.11L218.37,104a6,6,0,1,0,0,6.72l13.18,6.85a6,6,0,1,0,5.58-3.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.58,383.29H231.34a.74.74,0,0,1-.74-.73V342a.74.74,0,0,1,.74-.74.73.73,0,0,1,.73.74v39.85h45.51a.74.74,0,1,1,0,1.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.49,377.72l-.31-2.93c.27,0,27.31-3.13,39.19-21l2.45,1.64C260.17,374.46,232.66,377.6,231.49,377.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.26 352.16 267.65 354.47 273.27 358.22 273.26 352.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.88,292.65H404.8a.4.4,0,0,1-.4-.4v-22a.4.4,0,1,1,.8,0v21.61h24.68a.4.4,0,0,1,0,.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.89,289.63l-.17-1.59c.14,0,14.81-1.7,21.25-11.38l1.33.89C420.44,287.86,405.52,289.56,404.89,289.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.54 275.76 424.5 277.01 427.54 279.05 427.54 275.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.52,225.24v15.94c0,1.49,2.62,2.7,5.8,2.7H94a3,3,0,0,0,3-3v-4a6.57,6.57,0,0,1,.92-3.35h0a6.53,6.53,0,0,0,.92-3.36v-3.86a3,3,0,0,0-3-3H84V213.25c0-2.34-.66-5.49-3.45-5.49h0s-.78,10.24-6,14.4A3.88,3.88,0,0,0,73.52,225.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.33,
    y: 225.04,
    width: 4.95,
    height: 16.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.94,163.83v9.93c0,.93,1.63,1.68,3.61,1.68h9.12a1.85,1.85,0,0,0,1.85-1.85V171.1a4,4,0,0,1,.58-2.09h0a4.19,4.19,0,0,0,.57-2.1v-2.4a1.85,1.85,0,0,0-1.85-1.85h-7.35v-6.29c0-1.46-.42-3.42-2.15-3.42h0s-.49,6.37-3.71,9A2.4,2.4,0,0,0,340.94,163.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.08,
    y: 163.71,
    width: 3.08,
    height: 10.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.51,
    cy: 96.87,
    r: 12.98,
    transform: "translate(-26.76 129.14) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.51,
    cy: 96.87,
    r: 11.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.2,102v1.62H142v-1.6a6.37,6.37,0,0,1-3.54-1.2l.65-1.46a5.53,5.53,0,0,0,2.89,1.1V97.61c-1.6-.39-3.32-.91-3.32-2.92,0-1.47,1.07-2.76,3.32-3V90.08h1.19v1.61a6,6,0,0,1,2.93.88L145.54,94a5.89,5.89,0,0,0-2.34-.78v2.91c1.6.39,3.35.9,3.35,2.91C146.55,100.54,145.46,101.81,143.2,102ZM142,95.86V93.29c-1,.16-1.46.68-1.46,1.31S141.17,95.61,142,95.86Zm2.69,3.34c0-.71-.64-1-1.5-1.29v2.56C144.25,100.31,144.7,99.82,144.7,99.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.76,
    cy: 121.32,
    r: 11.64,
    transform: "translate(188.3 480.57) rotate(-76.72)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.76,
    cy: 121.32,
    r: 10.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.38,126v1.45h-1.07V126a5.61,5.61,0,0,1-3.17-1.07l.58-1.31a5,5,0,0,0,2.59,1V122c-1.44-.35-3-.81-3-2.61,0-1.32,1-2.48,3-2.67v-1.47h1.07v1.44a5.68,5.68,0,0,1,2.62.79l-.53,1.31a5.39,5.39,0,0,0-2.09-.7v2.62c1.43.35,3,.8,3,2.6C401.38,124.61,400.41,125.75,398.38,126Zm-1.07-5.54v-2.31c-.92.14-1.31.61-1.31,1.18S396.56,120.2,397.31,120.42Zm2.41,3c0-.64-.57-.93-1.34-1.15v2.29C399.32,124.41,399.72,124,399.72,123.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.47,
    cy: 342.88,
    r: 11.64,
    transform: "translate(-96.88 563.35) rotate(-76.72)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.47,
    cy: 342.88,
    r: 10.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.08,347.52V349H307v-1.44a5.61,5.61,0,0,1-3.17-1.07l.58-1.31a5,5,0,0,0,2.59,1v-2.59c-1.44-.35-3-.81-3-2.61,0-1.32,1-2.48,3-2.67v-1.47h1.06v1.44a5.57,5.57,0,0,1,2.63.79l-.53,1.31a5.38,5.38,0,0,0-2.1-.7v2.62c1.44.35,3,.8,3,2.6C311.09,346.17,310.12,347.31,308.08,347.52ZM307,342v-2.31c-.92.14-1.31.61-1.31,1.18S306.27,341.76,307,342Zm2.41,3c0-.64-.57-.93-1.35-1.15v2.29C309,346,309.43,345.53,309.43,345Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.66,
    cy: 356.15,
    r: 11.64,
    transform: "translate(-268.31 373.27) rotate(-76.72)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.66,
    cy: 356.15,
    r: 10.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.28,360.78v1.46h-1.06V360.8A5.75,5.75,0,0,1,98,359.72l.59-1.31a4.92,4.92,0,0,0,2.59,1v-2.59c-1.44-.35-3-.82-3-2.62,0-1.32,1-2.47,3-2.67v-1.46h1.06v1.44a5.46,5.46,0,0,1,2.63.79l-.53,1.3a5.43,5.43,0,0,0-2.1-.7v2.62c1.44.35,3,.8,3,2.6C105.29,359.44,104.31,360.58,102.28,360.78Zm-1.06-5.54v-2.31c-.92.15-1.31.61-1.31,1.18S100.47,355,101.22,355.24Zm2.41,3c0-.63-.57-.93-1.35-1.15v2.29C103.23,359.23,103.63,358.79,103.63,358.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,154.08l8-22.09a23.49,23.49,0,0,1,13.51,12.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,154.08l6.85,22.49a23.4,23.4,0,0,1-6.85,1,23.52,23.52,0,1,1,0-47,23.3,23.3,0,0,1,7.93,1.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,154.08l21.6-9.29a23.53,23.53,0,0,1-14.66,31.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,270.47l4.37-12a12.65,12.65,0,0,1,4.38,2.7,12.8,12.8,0,0,1,3,4.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,270.47,382,282.69a12.78,12.78,0,1,1,.58-24.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,270.47,390,265.42a12.68,12.68,0,0,1,1,5.05,12.81,12.81,0,0,1-9,12.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.53,225.09a79.59,79.59,0,0,0-11.41-27.45l9.82-11.87-21-21-11.87,9.83a79.29,79.29,0,0,0-27.45-11.41l-1.44-15.3H242.45L241,163.17a79.4,79.4,0,0,0-27.45,11.41l-11.87-9.83-21,21,9.83,11.87a79.21,79.21,0,0,0-11.41,27.45l-15.3,1.44v29.72l15.3,1.44a79.29,79.29,0,0,0,11.41,27.45L180.67,297l21,21,11.87-9.83A79.4,79.4,0,0,0,241,319.61l1.44,15.3h29.72l1.44-15.3a79.29,79.29,0,0,0,27.45-11.41L312.93,318l21-21-9.82-11.87a79.67,79.67,0,0,0,11.41-27.45l15.3-1.44V226.53Zm-38,16.3a40.23,40.23,0,1,1-40.23-40.23A40.23,40.23,0,0,1,297.54,241.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.73,179.55a15.71,15.71,0,0,0-2.26-5.46l1.95-2.36-4.18-4.18-2.36,1.95a16,16,0,0,0-5.46-2.27l-.28-3h-5.91l-.29,3a16.09,16.09,0,0,0-5.46,2.27l-2.36-1.95L400,171.73l1.95,2.36a15.73,15.73,0,0,0-2.27,5.46l-3,.28v5.91l3,.29a15.76,15.76,0,0,0,2.27,5.45L400,193.84l4.17,4.18,2.36-2a15.89,15.89,0,0,0,5.46,2.27l.29,3h5.91l.28-3a15.81,15.81,0,0,0,5.46-2.27l2.36,2,4.18-4.18-1.95-2.36a15.74,15.74,0,0,0,2.26-5.45l3-.29v-5.91Zm-7.55,3.24a8,8,0,1,1-8-8A8,8,0,0,1,423.18,182.79Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.39,278a16.09,16.09,0,0,0-2.27-5.46l1.95-2.36L146.89,266,144.53,268a15.73,15.73,0,0,0-5.46-2.27l-.28-3h-5.91l-.29,3a15.76,15.76,0,0,0-5.45,2.27L124.78,266l-4.18,4.17,2,2.36a15.89,15.89,0,0,0-2.27,5.46l-3,.29v5.91l3,.28a15.81,15.81,0,0,0,2.27,5.46l-2,2.36,4.18,4.18,2.36-2a15.57,15.57,0,0,0,5.45,2.27l.29,3h5.91l.28-3a15.54,15.54,0,0,0,5.46-2.27l2.36,2,4.18-4.18-1.95-2.36a16,16,0,0,0,2.27-5.46l3-.28v-5.91Zm-7.56,3.24a8,8,0,1,1-8-8A8,8,0,0,1,143.83,281.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.86,343.78a15.7,15.7,0,0,0-2.27-5.46l2-2.36-4.18-4.18-2.36,2a15.89,15.89,0,0,0-5.46-2.27l-.29-3h-5.9l-.29,3a15.89,15.89,0,0,0-5.46,2.27l-2.36-2L172.07,336l2,2.36a15.7,15.7,0,0,0-2.27,5.46l-3,.29V350l3,.28a15.7,15.7,0,0,0,2.27,5.46l-2,2.36,4.18,4.18,2.36-2a15.7,15.7,0,0,0,5.46,2.27l.29,3.05h5.9l.29-3.05A15.7,15.7,0,0,0,196,360.3l2.36,2,4.18-4.18-2-2.36a15.7,15.7,0,0,0,2.27-5.46l3-.28v-5.91ZM195.31,347a8,8,0,1,1-8-8A8,8,0,0,1,195.31,347Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84,157.57a10.29,10.29,0,0,0-1.5-3.59l1.29-1.56-2.75-2.75L92.32,151a10.29,10.29,0,0,0-3.59-1.5l-.19-2H84.65l-.19,2a10.42,10.42,0,0,0-3.6,1.5l-1.55-1.29-2.75,2.75L77.85,154a10.29,10.29,0,0,0-1.5,3.59l-2,.19v3.89l2,.19a10.34,10.34,0,0,0,1.5,3.6L76.56,167l2.75,2.75,1.55-1.28a10.6,10.6,0,0,0,3.6,1.49l.19,2h3.89l.19-2a10.47,10.47,0,0,0,3.59-1.49l1.56,1.28L96.63,167l-1.29-1.55a10.34,10.34,0,0,0,1.5-3.6l2-.19v-3.89Zm-5,2.14a5.27,5.27,0,1,1-5.27-5.27A5.27,5.27,0,0,1,91.86,159.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.06,143.63A7.61,7.61,0,0,0,111,141l.94-1.14-2-2-1.14.95a7.62,7.62,0,0,0-2.64-1.1l-.14-1.47h-2.85l-.14,1.47a7.62,7.62,0,0,0-2.64,1.1l-1.14-.95-2,2,.94,1.14A7.8,7.8,0,0,0,97,143.63l-1.47.14v2.86l1.47.13a7.8,7.8,0,0,0,1.09,2.64l-.94,1.14,2,2,1.14-.94a7.62,7.62,0,0,0,2.64,1.1l.14,1.47H106l.14-1.47a7.62,7.62,0,0,0,2.64-1.1l1.14.94,2-2L111,149.4a7.61,7.61,0,0,0,1.09-2.64l1.47-.13v-2.86Zm-3.65,1.57a3.87,3.87,0,1,1-3.86-3.87A3.86,3.86,0,0,1,108.41,145.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7,378.1a29.91,29.91,0,0,1,0-59.81h.24A29.91,29.91,0,0,1,372,378.1h-.3Zm1.3-2.34,1.24-.3c4.27-1,8.1-4.69,10.79-10.31l.53-1.12-1.21-.28A54.22,54.22,0,0,0,374,362.47l-1,0Zm-3.38-13.29a54.22,54.22,0,0,0-10.31,1.28l-1.22.28.54,1.12c2.68,5.62,6.52,9.29,10.79,10.31l1.23.3V362.43Zm17.8,3a30,30,0,0,1-2.76,4.86l1.33,1.43a27.82,27.82,0,0,0,5.38-4.22l1-1-1.29-.61c-.75-.35-1.56-.68-2.42-1l-.86-.31ZM355,365c-.85.31-1.66.64-2.41,1l-1.29.6,1,1a27.82,27.82,0,0,0,5.38,4.22l1.34-1.43a29.27,29.27,0,0,1-2.77-4.86l-.38-.83Zm-10.61-14.54A27.37,27.37,0,0,0,349.29,364l.51.72.78-.41a26.78,26.78,0,0,1,3.52-1.53l.91-.33-.3-.92a43.72,43.72,0,0,1-2-11.24l-.05-1h-8.42Zm46.54-.12a43.3,43.3,0,0,1-2,11.24l-.29.92.91.33a28,28,0,0,1,3.52,1.53l.77.4.51-.71a27.34,27.34,0,0,0,4.93-13.59l.09-1.08H391Zm-35.8.09A40.65,40.65,0,0,0,357,360.94l.28.89.9-.22a57.41,57.41,0,0,1,11.53-1.5l1,0V349.37h-15.6ZM373,360.08l1,0a57.32,57.32,0,0,1,11.53,1.5l.9.22.29-.89a41.51,41.51,0,0,0,1.86-10.52l.05-1.05H373Zm20.08-28a28.85,28.85,0,0,1-3.52,1.53l-.91.33.29.92a43.23,43.23,0,0,1,2,11.24l0,.95h8.42l-.09-1.08a27.65,27.65,0,0,0-4.92-13.58l-.5-.72Zm-7.58,2.74A56.62,56.62,0,0,1,374,336.28l-1,0V347h15.6l-.05-1a41.23,41.23,0,0,0-1.86-10.52l-.29-.88Zm-28.53.67A40.65,40.65,0,0,0,355.11,346l-.06,1h15.6V336.31l-1,0a57.33,57.33,0,0,1-11.53-1.49l-.9-.22Zm-7.68-3.1a27.54,27.54,0,0,0-4.91,13.58l-.09,1.08h8.41l.05-.95a43.65,43.65,0,0,1,2-11.24l.3-.92-.91-.33a28.18,28.18,0,0,1-3.52-1.53l-.78-.41ZM373,334l1,0a55.88,55.88,0,0,0,10.31-1.28l1.21-.28-.53-1.13c-2.69-5.62-6.52-9.28-10.79-10.31l-1.24-.29Zm-3.58-13c-4.27,1-8.11,4.69-10.79,10.31l-.54,1.13,1.22.28a55.67,55.67,0,0,0,10.31,1.28l1,0V320.64Zm-11.71,3.59a27.3,27.3,0,0,0-5.44,4.28l-1,1,1.28.6c.76.35,1.58.69,2.43,1l.87.31.38-.83A29.21,29.21,0,0,1,359,326Zm26.9,1.43a30,30,0,0,1,2.81,4.92l.39.84.86-.31c.85-.3,1.67-.64,2.43-1l1.28-.6-1-1a27.36,27.36,0,0,0-5.45-4.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.41,141.29a17.72,17.72,0,0,1,0-35.43h.14a17.72,17.72,0,0,1,0,35.43h-.18Zm.77-1.39.73-.17c2.53-.61,4.8-2.78,6.39-6.11l.32-.67-.72-.16a32.2,32.2,0,0,0-6.11-.76l-.61,0Zm-2-7.87a32.09,32.09,0,0,0-6.1.76l-.73.16.32.67c1.6,3.33,3.87,5.5,6.4,6.11l.73.17V132Zm10.56,1.81a18.61,18.61,0,0,1-1.64,2.88l.79.85a16.77,16.77,0,0,0,3.18-2.5l.6-.6-.76-.36c-.45-.21-.93-.4-1.44-.58l-.51-.19Zm-19.23-.32c-.5.18-1,.38-1.43.59l-.76.36.59.6a17.11,17.11,0,0,0,3.19,2.49l.79-.84a18.61,18.61,0,0,1-1.64-2.88l-.22-.5Zm-6.29-8.61a16.35,16.35,0,0,0,2.92,8.05l.3.42.46-.24a17.72,17.72,0,0,1,2.09-.91l.54-.19-.18-.54a26.23,26.23,0,0,1-1.16-6.66l0-.57h-5Zm27.58-.07a25.8,25.8,0,0,1-1.17,6.66l-.17.54.54.2a16.21,16.21,0,0,1,2.09.9l.45.24.3-.42a16.16,16.16,0,0,0,2.92-8.05l.06-.64h-5Zm-21.21,0a24.54,24.54,0,0,0,1.1,6.23l.17.53.53-.13a34.5,34.5,0,0,1,6.83-.89h.58v-6.35h-9.24Zm10.6,5.73h.57a34.5,34.5,0,0,1,6.84.89l.53.13.17-.53a24.54,24.54,0,0,0,1.1-6.23l0-.62h-9.24ZM307.08,114a16.21,16.21,0,0,1-2.09.91l-.54.2.17.54a25.8,25.8,0,0,1,1.17,6.66l0,.57h5l-.05-.64a16.4,16.4,0,0,0-2.91-8l-.3-.43Zm-4.49,1.63a33.1,33.1,0,0,1-6.84.88l-.57,0v6.35h9.24l0-.63a24.7,24.7,0,0,0-1.1-6.23l-.17-.52Zm-16.91.39a24.7,24.7,0,0,0-1.1,6.23l0,.63h9.24v-6.35l-.58,0a33.79,33.79,0,0,1-6.83-.88l-.53-.13Zm-4.55-1.83a16.4,16.4,0,0,0-2.91,8l-.05.64h5l0-.57a26.23,26.23,0,0,1,1.16-6.66l.18-.54-.54-.2a16.21,16.21,0,0,1-2.09-.91l-.46-.24Zm14.05,1,.61,0a33,33,0,0,0,6.11-.76l.72-.16-.32-.67c-1.59-3.33-3.86-5.5-6.39-6.11l-.73-.18Zm-2.12-7.72c-2.53.61-4.8,2.78-6.4,6.11l-.32.67.73.16a32.92,32.92,0,0,0,6.1.76l.62,0v-7.9Zm-6.94,2.12a16.44,16.44,0,0,0-3.23,2.54l-.59.6.76.35c.45.21.94.41,1.44.59l.52.19.22-.5a18.13,18.13,0,0,1,1.67-2.91Zm15.94.85a18.68,18.68,0,0,1,1.67,2.92l.22.49.51-.18c.51-.18,1-.38,1.44-.59l.76-.35-.59-.6a16,16,0,0,0-3.22-2.54Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "343.29 309.83 343.29 165.87 156.19 165.87 156.19 309.83 182.57 309.83 182.57 406.58 175.46 409.11 175.46 411.73 197.93 411.73 197.93 409.11 190.81 406.58 190.81 309.83 312.58 309.83 312.58 406.58 305.47 409.11 305.47 411.73 327.93 411.73 327.93 409.11 320.82 406.58 320.82 309.83 343.29 309.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.66,
    y: 167.87,
    width: 182.17,
    height: 137.37,
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.66,
    y: 167.87,
    width: 182.17,
    height: 137.37,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.68,
    y: 250.98,
    width: 5.74,
    height: 5.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.68,
    y: 267.49,
    width: 5.74,
    height: 5.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.68,
    y: 284,
    width: 5.74,
    height: 5.74,
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.68,
    y: 267.49,
    width: 5.74,
    height: 5.74,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.66,191.09a.25.25,0,0,0,.25-.25.25.25,0,0,0-.25-.25h-2.3v-9.38h2.3a.25.25,0,0,0,0-.5h-2.3v-2.57a.25.25,0,0,0-.25-.25.25.25,0,0,0-.25.25v2.57H258.63v-2.57a.25.25,0,0,0-.5,0v2.57H247.91v-2.57a.25.25,0,0,0-.5,0v2.57H237.18v-2.57a.25.25,0,0,0-.25-.25.25.25,0,0,0-.25.25v2.57H226.46v-2.57a.25.25,0,0,0-.5,0v2.57H215.74v-2.57a.25.25,0,0,0-.5,0v2.57H205v-2.57a.25.25,0,0,0-.25-.25.25.25,0,0,0-.25.25v2.57H194.29v-2.57a.25.25,0,0,0-.5,0v2.57H183.57v-2.57a.25.25,0,0,0-.5,0v2.57H173v.5h10.09v9.38H173v.5h10.09v9.39H173v.5h10.09v9.38H173v.5h10.09v9.39H173v.5h10.09v10.08a.25.25,0,0,0,.5,0V220.75h10.22v10.08a.25.25,0,0,0,.5,0V220.75h10.23v10.08a.25.25,0,0,0,.25.25.25.25,0,0,0,.25-.25V220.75h10.22v10.08a.25.25,0,1,0,.5,0V220.75H226v10.08a.25.25,0,0,0,.5,0V220.75h10.22v10.08a.25.25,0,0,0,.25.25.25.25,0,0,0,.25-.25V220.75h10.23v10.08a.25.25,0,0,0,.5,0V220.75h10.22v10.08a.25.25,0,1,0,.5,0V220.75h10.23v10.08a.25.25,0,0,0,.25.25.25.25,0,0,0,.25-.25V220.75h2.3a.25.25,0,0,0,0-.5h-2.3v-9.39h2.3a.25.25,0,0,0,.25-.25.25.25,0,0,0-.25-.25h-2.3V201h2.3a.25.25,0,0,0,0-.5h-2.3v-9.39Zm-77.87,29.16H183.57v-9.39h10.22Zm0-9.89H183.57V201h10.22Zm0-9.88H183.57v-9.39h10.22Zm0-9.89H183.57v-9.38h10.22Zm10.73,29.66H194.29v-9.39h10.23Zm0-9.89H194.29V201h10.23Zm0-9.88H194.29v-9.39h10.23Zm0-9.89H194.29v-9.38h10.23Zm10.72,29.66H205v-9.39h10.22Zm0-9.89H205V201h10.22Zm0-9.88H205v-9.39h10.22Zm0-9.89H205v-9.38h10.22ZM226,220.25H215.74v-9.39H226Zm0-9.89H215.74V201H226Zm0-9.88H215.74v-9.39H226Zm0-9.89H215.74v-9.38H226Zm10.72,29.66H226.46v-9.39h10.22Zm0-9.89H226.46V201h10.22Zm0-9.88H226.46v-9.39h10.22Zm0-9.89H226.46v-9.38h10.22Zm10.73,29.66H237.18v-9.39h10.23Zm0-9.89H237.18V201h10.23Zm0-9.88H237.18v-9.39h10.23Zm0-9.89H237.18v-9.38h10.23Zm10.72,29.66H247.91v-9.39h10.22Zm0-9.89H247.91V201h10.22Zm0-9.88H247.91v-9.39h10.22Zm0-9.89H247.91v-9.38h10.22Zm10.73,29.66H258.63v-9.39h10.23Zm0-9.89H258.63V201h10.23Zm0-9.88H258.63v-9.39h10.23Zm0-9.89H258.63v-9.38h10.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.02,
    y: 215.28,
    width: 6.21,
    height: 15.28,
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.28,
    y: 215.28,
    width: 1.96,
    height: 15.28,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.65,
    y: 208.76,
    width: 6.21,
    height: 21.8,
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.9,
    y: 208.76,
    width: 1.96,
    height: 21.8,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.27,
    y: 212.4,
    width: 6.21,
    height: 18.15,
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.53,
    y: 212.4,
    width: 1.96,
    height: 18.15,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.9,
    y: 205.39,
    width: 6.21,
    height: 25.17,
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.15,
    y: 205.39,
    width: 1.96,
    height: 25.17,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.53,
    y: 192.55,
    width: 6.21,
    height: 38.01,
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.78,
    y: 192.55,
    width: 1.96,
    height: 38.01,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.93,231.33H173.05a.5.5,0,0,1-.5-.5V176.46a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v53.87H275.93a.5.5,0,0,1,.5.5A.5.5,0,0,1,275.93,231.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,218a.5.5,0,0,1-.43-.24.51.51,0,0,1,.18-.69l10.42-6.2,15.82-6.55a.48.48,0,0,1,.29,0l17.35,3.61L235.74,201,261.2,181.5a.51.51,0,0,1,.7.1.5.5,0,0,1-.09.7L236.3,201.79a.6.6,0,0,1-.11.06l-16.62,7a.48.48,0,0,1-.29,0l-17.35-3.61-15.61,6.46L176,217.91A.48.48,0,0,1,175.7,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.93,231.33H173.05a.5.5,0,0,1-.5-.5V176.46a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v53.87H275.93a.5.5,0,0,1,.5.5A.5.5,0,0,1,275.93,231.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "263.31 180.49 258.47 182.24 260.38 184.72 263.31 180.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,205.28l6.21,20.39a21.32,21.32,0,1,1,1-40.46Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,205.28l7.29-20A21.3,21.3,0,0,1,324,196.76Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,205.28,324,196.85a21.31,21.31,0,0,1-13.29,28.8Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,205.28l6.21,20.39a21.32,21.32,0,1,1,1-40.46Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,205.28,324,196.85a21.31,21.31,0,0,1-13.29,28.8Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.66,257.1a.25.25,0,0,0,0-.5h-2.3v-9.39h2.3a.25.25,0,0,0,.25-.25.25.25,0,0,0-.25-.25h-2.3v-2.57a.25.25,0,0,0-.25-.25.25.25,0,0,0-.25.25v2.57H258.63v-2.57a.25.25,0,0,0-.5,0v2.57H247.91v-2.57a.25.25,0,0,0-.5,0v2.57H237.18v-2.57a.25.25,0,0,0-.25-.25.25.25,0,0,0-.25.25v2.57H226.46v-2.57a.25.25,0,0,0-.5,0v2.57H215.74v-2.57a.25.25,0,0,0-.5,0v2.57H205v-2.57a.25.25,0,0,0-.25-.25.25.25,0,0,0-.25.25v2.57H194.29v-2.57a.25.25,0,0,0-.5,0v2.57H183.57v-2.57a.25.25,0,0,0-.5,0v2.57H173v.5h10.09v9.39H173v.5h10.09v9.38H173v.5h10.09v9.39H173v.5h10.09v9.38H173v.5h10.09v10.09a.25.25,0,0,0,.5,0V286.75h10.22v10.09a.25.25,0,0,0,.5,0V286.75h10.23v10.09a.25.25,0,0,0,.25.25.25.25,0,0,0,.25-.25V286.75h10.22v10.09a.25.25,0,0,0,.5,0V286.75H226v10.09a.25.25,0,0,0,.5,0V286.75h10.22v10.09a.25.25,0,0,0,.25.25.25.25,0,0,0,.25-.25V286.75h10.23v10.09a.25.25,0,0,0,.5,0V286.75h10.22v10.09a.25.25,0,1,0,.5,0V286.75h10.23v10.09a.25.25,0,0,0,.25.25.25.25,0,0,0,.25-.25V286.75h2.3a.25.25,0,1,0,0-.5h-2.3v-9.38h2.3a.25.25,0,0,0,0-.5h-2.3V267h2.3a.25.25,0,0,0,.25-.25.25.25,0,0,0-.25-.25h-2.3V257.1Zm-77.87,29.15H183.57v-9.38h10.22Zm0-9.88H183.57V267h10.22Zm0-9.89H183.57V257.1h10.22Zm0-9.88H183.57v-9.39h10.22Zm10.73,29.65H194.29v-9.38h10.23Zm0-9.88H194.29V267h10.23Zm0-9.89H194.29V257.1h10.23Zm0-9.88H194.29v-9.39h10.23Zm10.72,29.65H205v-9.38h10.22Zm0-9.88H205V267h10.22Zm0-9.89H205V257.1h10.22Zm0-9.88H205v-9.39h10.22ZM226,286.25H215.74v-9.38H226Zm0-9.88H215.74V267H226Zm0-9.89H215.74V257.1H226Zm0-9.88H215.74v-9.39H226Zm10.72,29.65H226.46v-9.38h10.22Zm0-9.88H226.46V267h10.22Zm0-9.89H226.46V257.1h10.22Zm0-9.88H226.46v-9.39h10.22Zm10.73,29.65H237.18v-9.38h10.23Zm0-9.88H237.18V267h10.23Zm0-9.89H237.18V257.1h10.23Zm0-9.88H237.18v-9.39h10.23Zm10.72,29.65H247.91v-9.38h10.22Zm0-9.88H247.91V267h10.22Zm0-9.89H247.91V257.1h10.22Zm0-9.88H247.91v-9.39h10.22Zm10.73,29.65H258.63v-9.38h10.23Zm0-9.88H258.63V267h10.23Zm0-9.89H258.63V257.1h10.23Zm0-9.88H258.63v-9.39h10.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,286.25s6.53-9.88,10.59-9.88c4.28,0,6.55,5.51,10.22,5.51s6.29-12.13,10.73-12.13,6.77,15.08,11.22,15.08,8.68-18.35,13.38-18.35,5.2,5.77,7.56,5.77c2.83,0,5-15.65,11.23-15.65,6,0,6,9.88,10.72,9.88s3.72-15.5,10.73-15.5v46.11H173.05Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,286.25s6.53-9.88,10.59-9.88c4.28,0,6.55,5.51,10.22,5.51s6.29-12.13,10.73-12.13,6.77,15.08,11.22,15.08,8.68-18.35,13.38-18.35,5.2,5.77,7.56,5.77c2.83,0,5-15.65,11.23-15.65,6,0,6,9.88,10.72,9.88s3.72-15.5,10.73-15.5v46.11H173.05Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.4,286.53l-.84-.55c.27-.42,6.73-10.11,11-10.11,2.41,0,4.16,1.54,5.85,3,1.44,1.27,2.79,2.47,4.37,2.47s3-2.73,4.4-5.37c1.82-3.32,3.7-6.76,6.33-6.76s4.25,3.8,6.06,7.83c1.52,3.4,3.26,7.25,5.16,7.25s4.1-4.62,6-8.7c2.38-5,4.63-9.65,7.33-9.65,3,0,4.44,2.13,5.57,3.84.69,1,1.28,1.93,2,1.93s2-2.9,2.91-5.23c1.88-4.64,4.22-10.42,8.31-10.42,3.47,0,5.09,3,6.52,5.65,1.23,2.27,2.29,4.23,4.2,4.23,1.75,0,2.68-3,3.67-6.25,1.33-4.33,2.84-9.25,7.06-9.25v1c-3.48,0-4.82,4.35-6.11,8.55-1.09,3.57-2.13,7-4.62,7s-3.82-2.42-5.08-4.76c-1.36-2.52-2.77-5.12-5.64-5.12-3.42,0-5.62,5.43-7.39,9.8-1.37,3.39-2.36,5.85-3.83,5.85-1.26,0-2-1.16-2.84-2.38-1-1.59-2.24-3.39-4.73-3.39-2.07,0-4.38,4.83-6.43,9.09-2.28,4.76-4.44,9.26-6.95,9.26s-4.26-3.81-6.08-7.84c-1.52-3.39-3.25-7.24-5.14-7.24s-3.85,3.31-5.45,6.24-3.23,5.89-5.28,5.89-3.52-1.38-5-2.72-3.15-2.79-5.18-2.79C180.46,276.87,175.17,283.84,173.4,286.53Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,289.55a1.72,1.72,0,0,1-.32,0c-2.35-.28-3.64-3.1-4.69-5.37a18.1,18.1,0,0,0-1.08-2.13c-1.06-1.6-2.25-2.34-3.54-2.19-2,.24-3.73,1.9-5.28,3.36l-.67.63c-1.4,1.29-2.77,2.65-4.05,4.06l-.74-.67c1.31-1.43,2.69-2.82,4.11-4.13.22-.19.43-.4.66-.61,1.58-1.5,3.55-3.36,5.86-3.63,1.66-.21,3.22.71,4.48,2.63a17.38,17.38,0,0,1,1.16,2.26c.94,2,2.11,4.58,3.9,4.8s3.8-3.12,4.93-5.12c.21-.39.41-.73.58-1,.67-1.1,1.32-2.21,2-3.32,1.11-1.9,2.27-3.88,3.51-5.75a41.55,41.55,0,0,1,3.21-4.27c1.67-1.93,3.27-2.91,4.77-2.92a4,4,0,0,1,3.09,1.56,22.37,22.37,0,0,1,3.61,6.5,33.2,33.2,0,0,0,2.11,4.42,3.82,3.82,0,0,0,1.35,1.46c.93.47,2-.32,2.7-1.08a35.48,35.48,0,0,0,4.27-5.89l.32-.51c.14-.23.29-.48.44-.75,1-1.71,2.4-4.07,4.64-4.13,1.43,0,2.49,1.27,3.48,2.54,1.14,1.45,1.9,2.3,2.82,2a2.64,2.64,0,0,0,1-.82,28.42,28.42,0,0,0,4-7c.37-.82.73-1.64,1.11-2.44a6.23,6.23,0,0,1,.89-1.45,2.56,2.56,0,0,1,2.32-1c2,.33,3.51,3.61,4.38,5.58.12.26.22.49.31.67l.13.28c.89,1.86,1.81,3.79,3.29,4.31a3.41,3.41,0,0,0,2.62-.33l.88-.43c2.55-1.25,4.75-2.33,7.91-2.33v1c-2.93,0-4.94,1-7.47,2.22l-.89.44a4.3,4.3,0,0,1-3.38.37c-1.88-.66-2.93-2.87-3.86-4.82l-.13-.28c-.09-.19-.2-.42-.32-.7-.69-1.54-2.11-4.75-3.63-5a1.63,1.63,0,0,0-1.42.69,5.1,5.1,0,0,0-.72,1.22c-.39.79-.74,1.6-1.1,2.4a29.41,29.41,0,0,1-4.1,7.25,3.53,3.53,0,0,1-1.41,1.11c-1.68.62-2.88-.91-4-2.27-.84-1.06-1.7-2.16-2.65-2.16h0c-1.68,0-2.85,2-3.79,3.64-.17.28-.32.54-.47.77l-.31.51a36.94,36.94,0,0,1-4.4,6.06c-1.36,1.43-2.71,1.87-3.87,1.28a4.69,4.69,0,0,1-1.75-1.84,33.85,33.85,0,0,1-2.18-4.55,21.14,21.14,0,0,0-3.44-6.22,3.1,3.1,0,0,0-2.31-1.23h0c-1.2,0-2.55.88-4,2.57a40.72,40.72,0,0,0-3.12,4.17c-1.24,1.85-2.38,3.81-3.49,5.71-.65,1.11-1.31,2.23-2,3.33-.16.27-.35.61-.56,1C197.3,286.18,195.4,289.55,193,289.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,289.55a1.72,1.72,0,0,1-.32,0c-2.35-.28-3.64-3.1-4.69-5.37a18.1,18.1,0,0,0-1.08-2.13c-1.06-1.6-2.25-2.34-3.54-2.19-2,.24-3.73,1.9-5.28,3.36l-.67.63c-1.4,1.29-2.77,2.65-4.05,4.06l-.74-.67c1.31-1.43,2.69-2.82,4.11-4.13.22-.19.43-.4.66-.61,1.58-1.5,3.55-3.36,5.86-3.63,1.66-.21,3.22.71,4.48,2.63a17.38,17.38,0,0,1,1.16,2.26c.94,2,2.11,4.58,3.9,4.8s3.8-3.12,4.93-5.12c.21-.39.41-.73.58-1,.67-1.1,1.32-2.21,2-3.32,1.11-1.9,2.27-3.88,3.51-5.75a41.55,41.55,0,0,1,3.21-4.27c1.67-1.93,3.27-2.91,4.77-2.92a4,4,0,0,1,3.09,1.56,22.37,22.37,0,0,1,3.61,6.5,33.2,33.2,0,0,0,2.11,4.42,3.82,3.82,0,0,0,1.35,1.46c.93.47,2-.32,2.7-1.08a35.48,35.48,0,0,0,4.27-5.89l.32-.51c.14-.23.29-.48.44-.75,1-1.71,2.4-4.07,4.64-4.13,1.43,0,2.49,1.27,3.48,2.54,1.14,1.45,1.9,2.3,2.82,2a2.64,2.64,0,0,0,1-.82,28.42,28.42,0,0,0,4-7c.37-.82.73-1.64,1.11-2.44a6.23,6.23,0,0,1,.89-1.45,2.56,2.56,0,0,1,2.32-1c2,.33,3.51,3.61,4.38,5.58.12.26.22.49.31.67l.13.28c.89,1.86,1.81,3.79,3.29,4.31a3.41,3.41,0,0,0,2.62-.33l.88-.43c2.55-1.25,4.75-2.33,7.91-2.33v1c-2.93,0-4.94,1-7.47,2.22l-.89.44a4.3,4.3,0,0,1-3.38.37c-1.88-.66-2.93-2.87-3.86-4.82l-.13-.28c-.09-.19-.2-.42-.32-.7-.69-1.54-2.11-4.75-3.63-5a1.63,1.63,0,0,0-1.42.69,5.1,5.1,0,0,0-.72,1.22c-.39.79-.74,1.6-1.1,2.4a29.41,29.41,0,0,1-4.1,7.25,3.53,3.53,0,0,1-1.41,1.11c-1.68.62-2.88-.91-4-2.27-.84-1.06-1.7-2.16-2.65-2.16h0c-1.68,0-2.85,2-3.79,3.64-.17.28-.32.54-.47.77l-.31.51a36.94,36.94,0,0,1-4.4,6.06c-1.36,1.43-2.71,1.87-3.87,1.28a4.69,4.69,0,0,1-1.75-1.84,33.85,33.85,0,0,1-2.18-4.55,21.14,21.14,0,0,0-3.44-6.22,3.1,3.1,0,0,0-2.31-1.23h0c-1.2,0-2.55.88-4,2.57a40.72,40.72,0,0,0-3.12,4.17c-1.24,1.85-2.38,3.81-3.49,5.71-.65,1.11-1.31,2.23-2,3.33-.16.27-.35.61-.56,1C197.3,286.18,195.4,289.55,193,289.55Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.31,286.63l-.66-.75c.22-.2,5.46-4.82,10.35-4.82a15.38,15.38,0,0,1,5.88,1.25,12.9,12.9,0,0,0,4.91,1.1c2,0,3.81-2.61,5.56-5.14s3.29-4.74,5.17-4.74,3.43,1.76,5.12,3.62,3.56,3.91,5.6,3.91,4.79-3.18,7.28-6c2.7-3,5.24-5.91,7.37-5.91a7.18,7.18,0,0,1,5.1,2.39c.75.68,1.34,1.22,2,1.22.52-.26,1.76-3.53,2.75-6.16,2.32-6.1,4.94-13,8.21-13,2.9,0,5,4.33,7,8.53,1.42,2.91,3,6.22,4.31,6.22s2.61-1.93,3.93-4c1.62-2.5,3.45-5.32,6.11-5.32h.07v1c-2.14,0-3.77,2.45-5.33,4.86s-2.87,4.42-4.77,4.42-3.44-3.14-5.21-6.79-3.86-8-6.13-8c-2.58,0-5.4,7.45-7.27,12.38s-2.67,6.8-3.69,6.8a4.22,4.22,0,0,1-2.63-1.48,6.28,6.28,0,0,0-4.43-2.13c-1.68,0-4.19,2.83-6.62,5.58-2.89,3.25-5.62,6.33-8,6.33s-4.44-2.16-6.34-4.24c-1.54-1.69-3-3.29-4.38-3.29s-2.88,2.2-4.35,4.31c-1.9,2.74-3.86,5.57-6.38,5.57a13.94,13.94,0,0,1-5.26-1.16,14.53,14.53,0,0,0-5.53-1.19C178.49,282.06,173.36,286.58,173.31,286.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.93,297.34H173.05a.5.5,0,0,1-.5-.5V242.46a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v53.88H275.93a.5.5,0,0,1,.5.5A.5.5,0,0,1,275.93,297.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.93,297.34H173.05a.5.5,0,0,1-.5-.5V242.46a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v53.88H275.93a.5.5,0,0,1,.5.5A.5.5,0,0,1,275.93,297.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 250.48,
    width: 24.64,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 253.32,
    width: 24.64,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 256.15,
    width: 24.64,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 258.99,
    width: 14.64,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 266.99,
    width: 24.64,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 269.82,
    width: 24.64,
    height: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 272.66,
    width: 24.64,
    height: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 275.5,
    width: 7.64,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 283.5,
    width: 24.64,
    height: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 286.33,
    width: 24.64,
    height: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 289.17,
    width: 24.64,
    height: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 298.47,
    y: 292,
    width: 19.64,
    height: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.57,88.86H333a10.87,10.87,0,0,0-10.86,10.87v30.71A10.86,10.86,0,0,0,333,141.3h17.59l5.35,11.47,2-11.47h6.7a10.87,10.87,0,0,0,10.87-10.86V99.73A10.87,10.87,0,0,0,364.57,88.86Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.34,116.38c1.26-3.27,4.34-5.13,6.9-4.15s3.6,4.43,2.35,7.7-4.35,5.12-6.9,4.14S355.08,119.65,356.34,116.38Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,108.54,339.88,97s5.32,8.14,11.63,10.56l-2.2,5.73-.35.9-2.2,5.74c-6.31-2.43-15.71,0-15.71,0Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.34,116.38c1.26-3.27,4.34-5.13,6.9-4.15s3.6,4.43,2.35,7.7-4.35,5.12-6.9,4.14S355.08,119.65,356.34,116.38Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,108.54,339.88,97s5.32,8.14,11.63,10.56l-2.2,5.73-.35.9-2.2,5.74c-6.31-2.43-15.71,0-15.71,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.64,122.59s-3.33,6.69-6.94,9.48a.65.65,0,0,1-.85,0l-4-3.67a.66.66,0,0,1,.1-1c1.55-1,5.14-3.41,7-6.36C355.39,117.11,357.64,122.59,357.64,122.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.15,120.28c1.45.56,4.64-4.24,7.12-10.71s3.33-12.16,1.88-12.72-4.63,4.24-7.12,10.71S329.71,119.72,331.15,120.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,99.62a30.35,30.35,0,0,1-2,8.27l-.41,1.09c-.12.3-.23.61-.36.9a31.51,31.51,0,0,1-4,7.44c-.69.86-1.28,1.28-1.68,1.12-1.16-.44-.33-5.4,1.85-11.07s4.88-9.91,6-9.47C339.7,98,339.87,98.66,339.85,99.62Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,99.62a30.35,30.35,0,0,1-2,8.27l-.41,1.09c-.12.3-.23.61-.36.9a31.51,31.51,0,0,1-4,7.44A32.07,32.07,0,0,1,335.5,108,33.06,33.06,0,0,1,339.85,99.62Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.39,125.11s1.29-1.23,3.23-6.27c2.09-5.45,1.81-6.85,1.81-6.85l-14.09-5.41s.1,1.85-1.86,7-3.18,6.15-3.18,6.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.11,109.88c.13-.3.24-.6.36-.91s.28-.73.41-1.09l-1.41-.23a.63.63,0,0,0-.69.45l-.08.21a.62.62,0,0,0,.21.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.11,109.88c.13-.3.24-.6.36-.91s.28-.73.41-1.09l-1.41-.23a.63.63,0,0,0-.69.45l-.08.21a.62.62,0,0,0,.21.79Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.39,125.11s1.29-1.23,3.23-6.27c2.09-5.45,1.81-6.85,1.81-6.85l-14.09-5.41s.1,1.85-1.86,7-3.18,6.15-3.18,6.15Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "372.02 410.29 364.87 410.29 364.58 393.73 371.73 393.73 372.02 410.29",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.94,409.46h7.81a.61.61,0,0,1,.6.49l1.25,6.36a1.07,1.07,0,0,1-1.06,1.27c-2.82-.05-6.88-.22-10.43-.22-4.13,0-7.72.23-12.57.23-2.94,0-3.68-3-2.44-3.24,5.62-1.22,10.2-1.35,15.1-4.33A3.35,3.35,0,0,1,364.94,409.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.37,404.91H361.72c-1.35-16.31-5.75-70.69-6-89.29-.17-14.9.92-45,1.58-61.54H382c-1.32,16.45-3.66,46.66-4.49,63.22C376.63,335.53,374.89,388.79,374.37,404.91Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,315.62c.22,18.6,4.61,73,6,89.29h12.66c.38-12.16,1.47-45.48,2.38-68.92.29-7.63.56-14.21.79-18.69.5-10,1.55-24.88,2.58-38.76.69-9.18,1.37-17.91,1.9-24.46H357.33C356.67,270.58,355.58,300.72,355.75,315.62Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9,402.39c-.06,0,.56,5,.56,5h14.73l.51-4.49Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.75,336c.29-7.63.56-14.21.79-18.69.5-10,1.27-21.07,2.3-34.95-2.79-.78-7.35-2.8-8.24-4.35l3.24,4.34C374.3,293,374.92,317.91,376.75,336Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.16 410.29 391.01 410.29 389.98 393.73 397.13 393.73 398.16 410.29",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.87,404.91H387.22c-.73-5.71-2-16.08-3.46-28-2.66-22-5.77-49.24-6.44-61.33-.41-7.53-.68-18.95-.85-30.54-.17-11.34-.24-22.83-.28-31h23c.38,20.48.1,46.65,0,63.21C399.07,335.53,399.68,388.79,399.87,404.91Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.87,404.91H387.22c-.73-5.71-2-16.08-3.46-28-2.66-22-5.77-49.24-6.44-61.33-.41-7.53-.68-18.95-.85-30.54-.17-11.34-.24-22.83-.28-31h23c.38,20.48.1,46.65,0,63.21C399.07,335.53,399.68,388.79,399.87,404.91Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.39,402.39c-.05,0,.78,5,.78,5h14.74l.31-4.49Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9,402.39c-.06,0,.56,5,.56,5h14.73l.51-4.49Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.39,402.39c-.05,0,.78,5,.78,5h14.74l.31-4.49Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,409.46h7.81a.62.62,0,0,1,.61.49l1.53,6.36a1,1,0,0,1-1,1.27c-2.82-.05-6.89-.22-10.43-.22-4.14,0-7.71.23-12.57.23-2.93,0-3.8-3-2.58-3.24,5.57-1.22,10.14-1.35,14.92-4.33A3.17,3.17,0,0,1,391,409.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.94,208.6l-7.79-5.5,5.83-6s6,3.08,5.41,8.6Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.09 197.05 317.5 193.65 320.98 197.15 315.15 203.1 312.09 197.05",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.32,194.41c-7.4,2.18-11,15.17-17.13,27.44l-17.76-17.64-5.64,5s16.26,25.82,23.94,25.83c9.57,0,19.52-26.62,19.52-26.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.25,208.44s-1.58,4.21-4.08,9.29c-2.42,4.92-5.72,10.66-9.29,14.13-2,1.95-4.09,3.19-6.16,3.19-7.67,0-23.92-25.83-23.92-25.83l5.63-5,17.76,17.64c6.09-12.27,9.73-25.26,17.13-27.44Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.17,217.73c-2.42,4.92-5.72,10.66-9.29,14.13.39-11.77,6.16-23.26,6.16-23.26A25.51,25.51,0,0,1,360.17,217.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.19,196.4c-6.3,35-4,57.69-4,57.69s-29.81.68-41.85,0c-6.42-42.46,4-59.68,4-59.68a77.74,77.74,0,0,1,9.52-1.31c.67,0,1.36-.08,2.06-.11a149.26,149.26,0,0,1,17,1c1.07.11,2.16.26,3.21.41C398.46,195.16,403.19,196.4,403.19,196.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.19,196.39c-.78,4.35-1.43,8.51-2,12.44-.84,6.22-1.41,11.92-1.78,17-.11,1.54-.21,3-.29,4.45-.3,5.23-.38,9.68-.37,13.29,0,6.78.41,10.51.41,10.51s-29.81.69-41.85,0c-6.43-42.45,4-59.67,4-59.67a76.66,76.66,0,0,1,9.52-1.3c.67-.06,1.36-.09,2.06-.12a149.56,149.56,0,0,1,17,1c1.06.11,2.14.26,3.2.41C398.46,195.16,403.19,196.39,403.19,196.39Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.44,193.61c-2.56,2.68-6.6,4.92-13.06,4.68-4.95-.19-5.64-3.31-4.77-5,3-.62,4.37-1.93,4.78-3.59s-.16-3.92-1-6l8.35-7,1.42-1.19c0,.4-.06.82-.08,1.27a42.34,42.34,0,0,0,0,4.9C383.34,186.23,384.43,191.25,387.44,193.61Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.07,181.63c-1.56,3.18-4.29,7-8.68,8.06.46-1.77-.16-3.92-1-6l8.35-7c.45,0,.89,0,1.34.08A42.34,42.34,0,0,0,383.07,181.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,199.15c-1.51.86-3,1.72-4.54,2.6a334.24,334.24,0,0,0-.08,34.24c-.76,1.28-1.51,2.56-2.25,3.86-1-1.41-1.92-2.82-2.86-4.25a335.86,335.86,0,0,1,3.51-33.93c-.52-1-1-2-1.54-3l4.51-1.63C376.82,197.74,377.91,198.45,379,199.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,227.19c11.12.43,20.2,1.86,25,1.79-.3,5.22-.38,11-.37,14.59-21-4.12-27.6-10-27.6-10Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.22,208.83c-.84,6.22-1.41,11.92-1.78,17-4-8.16-1-18-1-18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.88,162.66c-1.23,2.81-1.38,8.82,2.89,7.33S366,157.85,363.88,162.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.36,168.87c-.37,7.51-.2,11.92-3.95,15.78-5.64,5.81-15,2.4-16.85-5.09-1.7-6.74-.81-17.88,6.51-20.89A10.37,10.37,0,0,1,384.36,168.87Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,171c0,.61-.31,1.1-.71,1.1s-.73-.49-.73-1.1.31-1.11.71-1.11S373,170.38,373,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.07,171c0,.61-.32,1.11-.72,1.11s-.73-.49-.73-1.1.31-1.11.71-1.11S366.06,170.4,366.07,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.27,171.31a21.25,21.25,0,0,1-2.91,5.05,3.61,3.61,0,0,0,2.91.48Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.09,168.76a.37.37,0,0,1-.34-.14,2.9,2.9,0,0,0-2.31-1.19.37.37,0,0,1-.39-.33.36.36,0,0,1,.33-.39,3.63,3.63,0,0,1,2.94,1.48.35.35,0,0,1-.23.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.05,168.64a.36.36,0,0,1-.2,0,.36.36,0,0,1-.17-.48,3.55,3.55,0,0,1,2.56-2,.37.37,0,0,1,.4.31.36.36,0,0,1-.3.41,2.74,2.74,0,0,0-2,1.62A.34.34,0,0,1,363.05,168.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.57,162.85s2.07-1.47,3,.12.89,5.85.89,5.85l.41-.76s2.66,9.48,6.53,7.1,9.55-12,.52-16.92c0,0-1-2.29-6.93-3.42s-13.18,2.56-14.41,6.5.49,6.14.49,6.14a5.72,5.72,0,0,1,1.15-2.34,2.48,2.48,0,0,0,1.49,1.82,4.32,4.32,0,0,1,.48-2.33,5,5,0,0,0,1,1.9c.43-4.06,3.19-4.89,4.07-4.86A1.48,1.48,0,0,1,372.57,162.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.33,175.09a7,7,0,0,1-3.47,4.18c-2.23,1.14-3.86-.74-3.68-3.11.17-2.13,1.52-5.29,4-5.44A3.24,3.24,0,0,1,387.33,175.09Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.51,179.36a19.49,19.49,0,0,1,1.78,2.15l.44-.22c2-1,2.58-2.12,2.64-3.07a3,3,0,0,0-.28-1.33,2.61,2.61,0,0,0-.41-.66,10.6,10.6,0,0,1-3.5,2.78C368.78,179.24,368.51,179.36,368.51,179.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.18,179l.54.62c1.88-.95,3.07-1.87,3.37-2.74a2.61,2.61,0,0,0-.41-.66A10.6,10.6,0,0,1,369.18,179Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.73,181.29c2-1,2.58-2.12,2.64-3.07a7.06,7.06,0,0,0-2,1.56A2.68,2.68,0,0,0,370.73,181.29Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.24,190.55s-2.35,3-10.79,5.85a9.45,9.45,0,0,1-2.47-5.46l-4.47,2s-1.36,4.09.67,7l6.22-2.78,4.77,4.06s7.77-4.94,9.17-7.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.82,244.07H351.51a1.64,1.64,0,0,1-1.61-1.49l-3-28.28a1.35,1.35,0,0,1,1.36-1.49h21.3a1.65,1.65,0,0,1,1.62,1.49l3,28.28A1.34,1.34,0,0,1,372.82,244.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.82,244.07H351.51a1.64,1.64,0,0,1-1.61-1.49l-3-28.28a1.35,1.35,0,0,1,1.36-1.49h21.3a1.65,1.65,0,0,1,1.62,1.49l3,28.28A1.34,1.34,0,0,1,372.82,244.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,244.07H351.51a1.64,1.64,0,0,1-1.61-1.49l-3-28.28a1.35,1.35,0,0,1,1.36-1.49H368.7a1.66,1.66,0,0,1,1.62,1.49l3,28.28A1.34,1.34,0,0,1,371.93,244.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51,226.13a2.08,2.08,0,0,0-2.11,2.31,2.56,2.56,0,0,0,2.5,2.31,2.08,2.08,0,0,0,2.11-2.31A2.56,2.56,0,0,1,359.51,226.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.12,215.05H352.86a1.48,1.48,0,0,1-1.32-.85l-.67-1.39h14.85l-.43,1.39A1.19,1.19,0,0,1,364.12,215.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.9,225.68l-4.92-.41.21,6.55,4.14,2.17,9.5-.87.77-4.41C373.45,224.13,366.9,225.68,366.9,225.68Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.16,198.47c-5,6.34.49,18.75,3.12,32.19l-24.83-3.18L375,234.89s28.63,10.58,34.72,5.91c7.6-5.82,2.67-27-1.26-37.43a13.73,13.73,0,0,0-5.3-7A6.27,6.27,0,0,0,398.16,198.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.16,198.47c-5,6.34.49,18.75,3.12,32.19l-24.83-3.18L375,234.89s28.63,10.58,34.72,5.91c7.6-5.82,2.67-27-1.26-37.43a13.73,13.73,0,0,0-5.3-7A6.27,6.27,0,0,0,398.16,198.47Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.82,255.3q7.83-.11,15.65-.47c0,.89.09,1.79.13,2.68q-7.89.38-15.78.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,257.75q-3-.11-6-.24l.12-2.68c2,.1,3.94.17,5.92.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.9,255.1q9.32.3,18.64.21V258q-9.32.09-18.64-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,258.24l4.7.09a.24.24,0,0,0,.26-.24v-2.75a.26.26,0,0,0-.25-.25l-4.7-.09a.24.24,0,0,0-.25.24V258A.24.24,0,0,0,369.17,258.24Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.8,
    cy: 194.94,
    r: 17.96,
    transform: "translate(-105.68 134.74) rotate(-45)",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.46,191.13c0-1.51-1.3-2.54-3.37-2.54a5.09,5.09,0,0,0-4.4,2.08l-2.62-1.7c1.51-2.05,3.94-3.29,7.31-3.29,4,0,6.61,1.81,6.61,4.91,0,4.4-4.61,4.8-4.61,8H108C108,194.58,112.46,193.83,112.46,191.13Zm-4.94,11.79a2.15,2.15,0,1,1,2.16,2.1A2.07,2.07,0,0,1,107.52,202.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.8 207.77 107.35 211.09 109.8 218.42 112.26 211.09 109.8 207.77",
    style: {
      fill: "#9D7600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "125.03 350.42 126.83 417.59 124.29 417.59 121.33 350.42 125.03 350.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.54 351.95 93.81 351.95 86.61 417.59 83.67 417.59 90.3 347.28 116.54 347.98 116.54 351.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.2 347.98 150.4 347.98 152.06 347.98 159.14 417.59 157.54 417.59 157.23 415.06 157.48 417.59 155.88 417.59 147.75 352.11 121.26 352.11 121.05 417.59 119.39 417.59 119.27 417.59 117.61 417.59 116.54 347.98 118.2 347.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.27 417.59 118.19 347.98 152.06 347.98 159.14 417.59 157.54 417.59 149.4 352.11 121.26 352.11 121.05 417.59 119.27 417.59",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.81 351.95 91.96 351.95 84.94 417.59 86.61 417.59 93.81 351.95",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.05,337.61l-7.13-59.4c-.39-3.63-3.09-6.37-6.3-6.37H82.42a1.62,1.62,0,0,0-1.5,1.72V335.7c0,7.3,5.18,13.22,11.59,13.22H158.9a.78.78,0,0,0,.72-.83h0c0-3.27-2.32-5.92-5.19-5.92H133.55A4.8,4.8,0,0,1,129.05,337.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.92,273.56v62.13c0,7.31,5.18,13.23,11.58,13.23h66.4a.79.79,0,0,0,.73-.83,6.39,6.39,0,0,0-1.52-4.19,4.88,4.88,0,0,0-3.68-1.74H133.55a3.88,3.88,0,0,1-1.35-.24,5.05,5.05,0,0,1-3.15-4.32l-7.14-59.39c-.37-3.64-3.08-6.37-6.29-6.37H82.42a1.46,1.46,0,0,0-1.3.87A1.81,1.81,0,0,0,80.92,273.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.05,271.84V328.7c0,7.3,5.19,13.22,11.59,13.22H132.2a5.05,5.05,0,0,1-3.15-4.32l-7.14-59.39c-.37-3.64-3.08-6.37-6.29-6.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34,312.29a52.21,52.21,0,0,0-3.06-6.79l-28.4,1.56S87.79,335.17,100,342.38c3.67,2.18,9.73,3,16.4,3.18a13.8,13.8,0,0,0,14.13-13.78S130.51,317,129.34,312.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92,332.68V344c10.11,2.92,31.1,1.81,43.57.79A10.82,10.82,0,0,0,157.43,334v-9.3a7.39,7.39,0,0,0-4.8-6.93c-6-2.28-17-5.67-28.56-5.49A20.42,20.42,0,0,0,103.92,332.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36,365.48c-3.67,9.94-7.92,22.38-12.46,38.08l-.24.86-.27.9-4.68-1.14-1.76-.43s.06-.69.21-1.92c0-.26.06-.54.09-.83h0c1.26-10.95,6.12-51.15,10.94-59.5a33.12,33.12,0,0,1-9.6.32c-3-.51-6.6-21.16-6.6-21.16a63.93,63.93,0,0,1,15.41-2.18h.11s15.2,3.58,18.12,7.88C169.23,331.62,165.9,339.7,156.36,365.48Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.3,417.59l-11-4.84-3.47-3.88-1.07,1.46-1.31-.57c-.62-4.87,1.75-7.15,3-8.18l.37-.29.14-.11.06,0,.17-.13,0,0h0l.1-.06,6,2.66s.1.32.29.83c.6,1.69,2.09,5.56,3.73,7.62l.21.25a3.9,3.9,0,0,0,.61.61C152.82,416.61,150.3,417.59,150.3,417.59Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6,412.29c-1.71.67-4.14-1-6-3.24a32.82,32.82,0,0,1-2.91-4.87,10.38,10.38,0,0,0-1.55-2.35c-.25-.23-.49-.33-.7-.23v0l.37-.29.14-.11.06,0,.17-.13,0,0h0l.1-.06c.63-.47,1.33-1,1.33-1l4.84,2.14s.14.57.38,1.45c.63,2.24,2,6.5,3.49,8.48Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36,365.48c-3.67,9.94-7.92,22.38-12.46,38.08.63,2.24,2,6.5,3.49,8.48l.21.25a3.9,3.9,0,0,0,.61.61c4.61,3.71,2.09,4.69,2.09,4.69l-11-4.84-3.47-3.88-1.07,1.46-1.31-.57c-.62-4.87,1.75-7.15,3-8.18l.37-.29.14-.11.06,0,.17-.13,0,0h0c1.26-10.95,6.12-51.15,10.94-59.5a33.12,33.12,0,0,1-9.6.32c-3-.51-6.6-21.16-6.6-21.16a63.93,63.93,0,0,1,15.41-2.18h.11s-1.84.17-4.34,3.32c0,0,10.21,1.9,13,7.3C157.26,331.28,157,347.24,156.36,365.48Z",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,320.66s17.47,2.74,20.4,7c5,7.38-4,21.9-20.58,79.83l-6.45-1.59s3.72-52.56,9.3-62.25c0,0-7.46,1-11.6.32C117.75,343.11,114.38,325.36,132,320.66Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.31,417.22h1.43l.39-1.77,4.74,2.14h12s1.91-1.92-3.8-3.45a4.31,4.31,0,0,1-.81-.31c-3.05-1.42-7.38-6.25-7.38-6.25h-6.58a8.37,8.37,0,0,0-.54.95C123,410,121.79,413,124.31,417.22Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,408.53v0c.87-1,4.82,3.29,7.72,4.74,2.58,1.28,5.49,1.85,6.78.54-3.05-1.42-7.84-7.66-7.84-7.66h-5.29S124.06,407.91,123.75,408.53Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,317.17v2.38c0,.61-.72.86-1.32.86H115.23c-.61,0-1.35-.25-1.35-.86v-2.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,317.17v2.38c0,.61-.72.86-1.32.86H115.23c-.61,0-1.35-.25-1.35-.86v-2.38Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,317.17v2.38c0,.61-.72.86-1.32.86H131.44c-.61,0-1.34-.25-1.34-.86v-2.38Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14,292.43l-5.67,25.71a1.92,1.92,0,0,1-1.84,1.46h-31A1.25,1.25,0,0,1,132.5,318l5.66-25.52a1.77,1.77,0,0,1,1.84-1.26h31C171.8,291.21,172.32,291.59,172.14,292.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14,292.43l-5.67,25.71a1.92,1.92,0,0,1-1.84,1.46H134.72a1.25,1.25,0,0,1-1.17-1.61l5.67-25.52a1.75,1.75,0,0,1,1.84-1.26H171C171.8,291.21,172.32,291.59,172.14,292.43Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,305.5h0a4.42,4.42,0,0,1-4.09,4c-1.73,0-2.75-1.78-2.26-4s2.21-3.91,3.91-4c-.5,2.2.56,4,2.28,4Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.65,263.42c5.34,4.53,10.65,9.78,16.9,12.92l.09.05a3.28,3.28,0,0,0-1.83.13,3.8,3.8,0,0,0-2.47,4.18,1.49,1.49,0,0,0,.19.54l0,0c-2-3.27-4.78-6.17-7.24-9.17-2.74-3.17-5.49-6.39-8.21-9.62a2.25,2.25,0,0,1,3.09-3.23c3.4,2.61,6.69,5.32,9.88,8.18,3.35,3.12,6.82,6,9.45,9.88a7.28,7.28,0,0,1,.58,1.19,4.4,4.4,0,0,1-4.49,6,9.63,9.63,0,0,1-1.83-.39c-7.89-2.93-14.15-8.5-20.25-14-4.18-4.2,1.69-10.48,6.16-6.58Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56,269.63c-.33,6.41-5,13.05-5,13.05l-1.11-.62-5.54-3s-.12-.3-.31-.81-.43-1.11-.73-1.9c-1.55-4.12-4.37-11.84-4.91-15.11C126.48,260.44,129.66,263.29,137.56,269.63Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56,269.63c-.33,6.41-5,13.05-5,13.05l-1.11-.62-5.54-3s-.12-.3-.31-.81-.43-1.11-.73-1.9c-1.55-4.12-4.37-11.84-4.91-15.11C126.48,260.44,129.66,263.29,137.56,269.63Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,282.06l-5.54-3s-.12-.3-.31-.81a38.93,38.93,0,0,1,.49-4.83A12.13,12.13,0,0,1,131.48,282.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.74,270.46c0,.16.06.31.1.47,1.39,5.59,2.42,10.36,3.17,14.52a99.54,99.54,0,0,1,1.6,13.16,61.7,61.7,0,0,1-.26,9.3l29.76,1c1.17-9.67,1.76-15.47,2.19-21.37a89.88,89.88,0,0,0,.35-12.14c0-5.25-3.68-11.42-8.91-12.33-1.46-.25-3-.49-4.43-.67l-.79-.09a54.68,54.68,0,0,0-16.45.81C96.12,263.81,92.05,266.32,92.74,270.46Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.74,270.46c0,.16.06.31.1.47,1.39,5.59,2.42,10.36,3.17,14.52a99.54,99.54,0,0,1,1.6,13.16,61.7,61.7,0,0,1-.26,9.3l29.76,1c1.17-9.67,1.76-15.47,2.19-21.37a89.88,89.88,0,0,0,.35-12.14c0-5.25-3.68-11.42-8.91-12.33-1.46-.25-3-.49-4.43-.67l-.79-.09a54.68,54.68,0,0,0-16.45.81C96.12,263.81,92.05,266.32,92.74,270.46Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.61,298.61A99.54,99.54,0,0,0,96,285.45c3.33-4.65,6.53-8.55,6.53-8.55S109.54,291.3,97.61,298.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.55,276.34c-.39,6.33-1.59,16.11-1.15,22.26l-.22-.78c-.19-.36-.06,0,.15.21,2.39,2.66,5.49,4.73,8.44,6.9,3.18,2.28,7.87,5.43,11.15,7.68a2.25,2.25,0,0,1-2.07,4c-2.19-.85-4.28-1.8-6.4-2.76-5-2.49-17.74-8.17-19.06-13.77-1.35-8.41-.61-16.3.19-24.62a4.51,4.51,0,0,1,9,.92Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.38,311.49l-1.9-1.15a2.56,2.56,0,0,0-2.36-.17l-3.58,1.55a4.82,4.82,0,0,0-2.81,3.42l-.2.94c3,2.13,7.85,2.19,7.85,2.19l1.37.18a2.15,2.15,0,0,0,2.46-1.82l.38-2.72A2.47,2.47,0,0,0,126.38,311.49Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.38,263.13c-6,1.39-8.21,6.21-9.55,16.63,2.67,3.06,11.69,4.26,11.69,4.26S104.92,268.38,99.38,263.13Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.05,262.71c-.68.09,1.73,7.37,12,8.59s8.7-8,7.72-10.22C120.73,261.08,108.43,261.67,101.05,262.71Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.37,229.22s5.24-6.87,16.06-4.44,11.93,21.31,7.13,28.58a98.71,98.71,0,0,0-24.8,4.39s-6.21-13.24-4.35-21.48S101.37,229.22,101.37,229.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,247.84c1,4.39,2.21,12.4-.71,15.21,0,0,4.14-.48,12.71,5.21,2.65-3.55.8-4.77.8-4.77-4.89-1.32-4.92-4.92-4.21-8.28Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.53,250.85l5.08,4.36a13,13,0,0,0-.31,2.39c-1.87-.33-4.49-2.45-4.77-4.4A6.44,6.44,0,0,1,108.53,250.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6,239c1.09,7.07,1.4,10.07,5.3,13.57,5.86,5.26,14.22,2.86,15.25-4.27.93-6.42-1-16.9-8.17-19.45A9.16,9.16,0,0,0,101.6,239Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53,240.46c.07.59.43,1.07.81,1s.64-.51.57-1.11-.43-1.07-.81-1.05S110.47,239.86,110.53,240.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,239.93c.06.59.42,1.07.8,1s.64-.51.58-1.11-.43-1.07-.81-1.05S117.88,239.33,118,239.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.35,238.86l1.36-.47S119.11,239.54,118.35,238.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,241.33a18,18,0,0,0,2.5,3.73,2.4,2.4,0,0,1-2,.48Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,236.76a.31.31,0,0,0,.25-.09,2.52,2.52,0,0,1,2.3-.8.33.33,0,0,0,.4-.26.39.39,0,0,0-.29-.43,3.24,3.24,0,0,0-2.92,1,.35.35,0,0,0,0,.49A.35.35,0,0,0,109,236.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.56,235.88a.34.34,0,0,0,.31-.54,3.67,3.67,0,0,0-2.83-1.62.31.31,0,0,0-.31.35.38.38,0,0,0,.37.35,2.94,2.94,0,0,1,2.22,1.3A.38.38,0,0,0,120.56,235.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.94,239.39l1.35-.47S111.7,240.07,110.94,239.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,243.13s5.13-4.75,3.33-11.39c0,0,9.49-4.68,14.17,4.89,0,0,.13-8.52-9.24-9.42s-19.23,12.5-8,21.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.81,244.91a5.74,5.74,0,0,0,3.62,2.48c1.91.35,2.59-1.55,1.83-3.4-.68-1.66-2.49-3.84-4.3-3.36S98.75,243.31,99.81,244.91Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,240.7a.21.21,0,0,1-.19-.14c-4.54-12.1-15.94-8.6-16.06-8.56a.2.2,0,0,1-.25-.13.2.2,0,0,1,.13-.26c.12,0,11.88-3.65,16.56,8.81a.2.2,0,0,1-.12.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,248.56h0c-.14,0-3.36-.06-4.58-2.19a.24.24,0,0,1,.09-.32.23.23,0,0,1,.32.09c1.08,1.9,4.14,2,4.17,2a.23.23,0,0,1,.24.23A.24.24,0,0,1,115.8,248.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.84,280.92a.22.22,0,0,1-.15-.06,57.55,57.55,0,0,1-13.59-18.49.25.25,0,0,1,.14-.31.23.23,0,0,1,.3.13,56.88,56.88,0,0,0,13.17,18.05c.48-2.05,2.46-11.88-1.88-18.85a.23.23,0,0,1,.39-.25c5,7.95,1.88,19.49,1.85,19.61a.22.22,0,0,1-.16.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.13,280.47l.85.91a.48.48,0,0,1,0,.59l-.69,1.07a.48.48,0,0,1-.74.08l-.79-.76a.48.48,0,0,1-.09-.57l.63-1.21A.48.48,0,0,1,118.13,280.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.38,263.13c-6,1.39-8.21,6.21-9.55,16.63,2.67,3.06,11.69,4.26,11.69,4.26S104.92,268.38,99.38,263.13Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.85,261.14l-2.43-6.2-5,5.39s2.5,5.4,5.22,4Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.18 250.95 120.42 257.05 123.38 260.33 128.42 254.94 123.18 250.95",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.35,282.1a25.56,25.56,0,0,0,3.4,1.59l1,.35.62.17.3.08.08,0,.2,0,.42.06.21,0h.29l.6,0a4.41,4.41,0,0,0,1-.22,4.36,4.36,0,0,0,1.27-.7,4.27,4.27,0,0,0,1.1-1.3,4.41,4.41,0,0,0,.32-.75,3.9,3.9,0,0,0,.14-.59,3.81,3.81,0,0,0,.07-.59,2.24,2.24,0,0,0,0-.38,4.87,4.87,0,0,0-.08-.68,5.25,5.25,0,0,0-.21-.77l-.21-.51-.19-.38-.18-.3a13.19,13.19,0,0,0-1.24-1.71c-.39-.48-.78-.91-1.16-1.34-.77-.84-1.54-1.63-2.32-2.4-1.56-1.53-3.12-3-4.73-4.43-3.19-2.86-6.48-5.57-9.88-8.18a2.25,2.25,0,0,0-3.09,3.23v0c2.72,3.22,5.47,6.44,8.2,9.6,1.35,1.6,2.72,3.17,4,4.77.66.79,1.29,1.58,1.88,2.36.29.38.57.77.82,1.14a8,8,0,0,1,.54.9l0,0,0,0a.48.48,0,0,1-.06-.14,2.64,2.64,0,0,1-.11-.38,3.86,3.86,0,0,1-.06-.49v-.28a2.83,2.83,0,0,1,.05-.5,3.74,3.74,0,0,1,.12-.48,3.56,3.56,0,0,1,.29-.67,3.78,3.78,0,0,1,1-1.15,4.21,4.21,0,0,1,1.1-.61,3.24,3.24,0,0,1,.8-.18,1.76,1.76,0,0,1,.4,0h.31l.22,0,.1,0h0l-.07,0-.14-.06-.49-.22c-.69-.34-1.46-.81-2.24-1.3C141.11,273.75,136.29,281,138.35,282.1Z",
    style: {
      fill: "#e9b376"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyValuation);
export default __webpack_public_path__ + "static/media/strategy-valuation.6d48ef261e34971880a277c91b27d108.svg";
export { ForwardRef as ReactComponent };